import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToastPosition } from 'components/toast/toast';

export type ToastType = 'success' | 'error' | 'info';

interface ToastState {
  isVisible: boolean;
  text: string;
  type: ToastType;
  position: ToastPosition;
  duration: number;
  id: number;
}

const initialState: ToastState = {
  isVisible: false,
  text: '',
  type: 'info',
  position: 'top',
  duration: 6000,
  id: 0,
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (
      state,
      action: PayloadAction<{
        text: string;
        type?: ToastType;
        position?: ToastPosition;
        duration?: number;
      }>,
    ) => {
      state.isVisible = true;
      state.text = action.payload.text;
      state.type = action.payload.type || 'info';
      state.position =
        action.payload.position ||
        (typeof window !== 'undefined' && window.innerWidth <= 1024 ? 'top' : 'left');
      state.duration = action.payload.duration || 6000;
      state.id = Date.now();
    },
    hideToast: (state) => {
      state.isVisible = false;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
